import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BellRing, Lock } from "lucide-react";
import { toast } from "sonner";
import { Switch } from "@/components/ui/switch";
import { api, formatErr } from "@/lib/api";

const CATS = [
  ["comments", "Kommentare", "Wenn jemand deinen Beitrag kommentiert"],
  ["friends", "Freunde", "Freundschaftsanfragen, angenommene Anfragen und eingeladene Freunde"],
  ["messages", "Nachrichten", "Neue private Nachrichten"],
  ["birthdays", "Geburtstage", "Geburtstage deiner Freunde, Glückwünsche und dein Geburtstags-Geschenk"],
  ["reminders", "Erinnerungen", "Login-Serie am Abend und offene Tagesmissionen"],
  ["rewards", "Abzeichen & Geschenke", "Neue Abzeichen, Wunsch-Geschenke in Reichweite und Monats-Gewinner"],
];

export function PushPrefs() {
  const [prefs, setPrefs] = useState(null);
  useEffect(() => { api.get("/push/prefs").then(({ data }) => setPrefs(data)).catch(() => {}); }, []);
  const toggle = async (k, v) => {
    const prev = prefs;
    setPrefs({ ...prefs, [k]: v });
    try { const { data } = await api.put("/push/prefs", { [k]: v }); setPrefs(data); toast.success(v ? "Push-Nachrichten an" : "Push-Nachrichten aus"); }
    catch (e) { setPrefs(prev); toast.error(formatErr(e)); }
  };
  if (!prefs) return null;
  return (
    <div className="bg-white rounded-3xl p-6 border border-pink-100" data-testid="push-prefs">
      <h3 className="font-bold text-lg flex items-center gap-2"><BellRing className="w-5 h-5 text-rose-500" /> Push-Einstellungen</h3>
      <p className="text-xs text-slate-500 mt-1">Wähle, wofür du Push-Nachrichten aufs Handy bekommst. Unter „Mitteilungen“ siehst du trotzdem alles.</p>
      <ul className="divide-y divide-pink-50 mt-3">
        {CATS.map(([k, l, d]) => (
          <li key={k} className="flex items-center gap-3 py-3">
            <div className="flex-1 min-w-0"><p className="font-semibold text-sm">{l}</p><p className="text-xs text-slate-400">{d}</p></div>
            <Switch checked={prefs[k]} onCheckedChange={(v) => toggle(k, v)} data-testid={`push-pref-${k}`} className="data-[state=checked]:bg-rose-500 data-[state=unchecked]:bg-slate-300" />
          </li>
        ))}
        <li className="flex items-center gap-3 py-3 text-slate-400" data-testid="push-pref-always">
          <div className="flex-1 min-w-0"><p className="font-semibold text-sm text-slate-500">Ankündigungen von itzPlay</p><p className="text-xs">Nachrichten von Itzcouple an alle bleiben immer an</p></div>
          <Lock className="w-4 h-4" />
        </li>
      </ul>
      <Link to="/push" className="text-xs font-semibold text-rose-600 hover:underline" data-testid="push-prefs-guide-link">Push auf diesem Gerät einrichten →</Link>
    </div>
  );
}
